<script setup lang="ts">
import { pageMotion } from '@/motion/route-motion'
</script>

<template>
  <div
    :class="['route-progress', { 'is-travelling': pageMotion.busy }]"
    aria-hidden="true"
  >
    <span />
  </div>
  <p class="sr-only" aria-live="polite" aria-atomic="true">
    {{ pageMotion.announcement }}
  </p>
</template>
